var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.59,
    height: 16.18,
    viewBox: "0 0 18.59 16.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.473 -53.359)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.166 53.632)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.449,218.936h-3.287a.5.5,0,0,0-.5.5v6.449a.5.5,0,0,0,.5.5h3.287a.5.5,0,0,0,.5-.5v-6.449A.5.5,0,0,0,146.449,218.936Z",
    transform: "translate(-135.3 -210.474)",
    fill: "#2fd9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,131.8h-3.312a.511.511,0,0,0-.5.523l-.168,11.136a.511.511,0,0,0,.5.523h3.312a.511.511,0,0,0,.5-.523l.168-11.136A.511.511,0,0,0,283,131.8Z",
    transform: "translate(-265.216 -128.071)",
    fill: "#2fd9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.592,269.613H6.28a.5.5,0,0,0-.5.5v4.034a.5.5,0,0,0,.5.5H9.592a.5.5,0,0,0,.5-.5v-4.034A.5.5,0,0,0,9.592,269.613Z",
    transform: "translate(-4.879 -258.735)",
    fill: "#2fd9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.544.385a.326.326,0,0,0-.25-.134L9.8,0a.385.385,0,0,0-.058.768l2.474.168L7.667,4.495,4.191,1.768a.384.384,0,0,0-.5.019L.12,5.205A.384.384,0,0,0,.1,5.743a.346.346,0,0,0,.288.134.384.384,0,0,0,.269-.115L3.98,2.574,7.417,5.282a.384.384,0,0,0,.48,0l4.916-3.826-.192,2.385a.4.4,0,0,0,.365.4h.019A.384.384,0,0,0,13.39,3.9L13.64.654A.307.307,0,0,0,13.544.385Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 0, 1.189)",
    fill: "#2fd9ef",
    stroke: "#2fd9ef",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraction);
export default __webpack_public_path__ + "static/media/traction.986415b9a538fd689273eb4113f81db8.svg";
export { ForwardRef as ReactComponent };